import { useEffect } from "react";
import MainPageLayout from "../../components/layouts/MainPageLayout";
import { useLeaderboardStore } from "../../store/leaderboardStore";
import { Footer } from "../landing/Footer";
import { Leaderboard } from "./Leaderboard";
import { usePublicStore } from "../../store/publicStore";
import { useNavigate } from "react-router-dom";

export const LeaderboardCurrentMatch = () => {
  const {
    leaderboardMatchId,
    setLeaderboardMatchId,
    leaderboardLevel,
    backClicked,
    setLeaderboardLevel,
  } = useLeaderboardStore();
  const { currentSeason, getCurrentSeason, matchSetups, getMatchSetups } =
    usePublicStore();

  const navigate = useNavigate();

  useEffect(() => {
    setLeaderboardLevel("match");
  }, [setLeaderboardLevel]);
  useEffect(() => {
    if (leaderboardLevel === "season" && !leaderboardMatchId && backClicked) {
      navigate("/leaderboard");
    }
  }, [leaderboardLevel, leaderboardMatchId]);

  useEffect(() => {
    // get current season all matches and find the currently in progress match or last played match
    // and set the leaderboard match id
    if (currentSeason) {
      if (matchSetups.length === 0) {
        getMatchSetups();
      } else {
        const currentMatch =
          matchSetups.find((match) => match.matchInProgress) ||
          [...matchSetups]
            .sort((a, b) => b.date?.localeCompare(a.date ?? "") ?? -1)
            .find((match) => match.isMatchCompleted);
        if (currentMatch) {
          setLeaderboardMatchId(currentMatch.matchId);
        }
      }
    }
  }, [
    setLeaderboardMatchId,
    getCurrentSeason,
    currentSeason,
    matchSetups,
    getMatchSetups,
  ]);

  return (
    <MainPageLayout Footer={<Footer />}>
      <Leaderboard />
    </MainPageLayout>
  );
};
